import { RouteRecordRaw } from 'vue-router'

const pageTitle = (name: string): string => {
  return `pagesTitle.${name}`
}

/*
 * 静态路由
 */
const staticRoutes: Array<RouteRecordRaw> = [
  {
    // 首页
    path: '/',
    name: '/',
    redirect: '/admin/home'
  },
  {
    // 登录页
    path: '/login',
    name: 'adminLogin',
    component: () => import('/@/views/login.vue'),
    meta: {
      title: pageTitle('adminLogin')
    }
  },
  {
    path: '/:path(.*)*',
    redirect: '/404'
  },
  {
    // 404
    path: '/404',
    name: 'notFound',
    component: () => import('/@/views/error/404.vue'),
    meta: {
      title: pageTitle('notFound') // 页面不存在
    }
  },
  {
    // 后台找不到页面了-可能是路由未加载上
    path: '/admin:path(.*)*',
    redirect: to => {
      return {
        name: 'adminMainLoading',
        params: {
          to: JSON.stringify({
            path: to.path,
            query: to.query
          })
        }
      }
    }
  },
  {
    // 无权限访问
    path: '/401',
    name: 'noPower',
    component: () => import('/@/views/error/401.vue'),
    meta: {
      title: pageTitle('noPower')
    }
  }
]

if (import.meta.env.MODE === 'development') {
  // demo
  staticRoutes.push({
    path: '/demo',
    name: 'demo',
    component: () => import('/@/views/demo/index.vue'),
    meta: {
      title: pageTitle('demo')
    }
  })
}

/*
 * 后台基础静态路由
 */
const adminBaseRoute: RouteRecordRaw = {
  path: '/admin',
  name: 'admin',
  component: () => import('/@/layouts/index.vue'),
  redirect: '/admin/loading',
  meta: {
    title: pageTitle('admin')
  },
  children: [
    {
      path: 'loading/:to?',
      name: 'adminMainLoading',
      component: () => import('/@/layouts/common/components/loading.vue'),
      meta: {
        title: pageTitle('Loading')
      }
    }
  ]
}

staticRoutes.push(adminBaseRoute)

/**
 * V1.0.0 后台菜单前端写死，数据格式按照接口返回格式定义
 */
const mockApiStaticRoutes: any[] = [
  // {
  //   id: 10001,
  //   pid: 0,
  //   type: 'menu',
  //   title: '首页',
  //   name: 'adminDashboard',
  //   path: 'dashboard',
  //   menu_type: 'tab',
  //   url: '',
  //   component: '/src/views/dashboard.vue',
  //   keepalive: 'dashboard',
  //   extend: 'none'
  // },
  // {
  //   id: 10002,
  //   pid: 0,
  //   type: 'menu',
  //   title: '客户管理',
  //   name: 'customer',
  //   path: 'customer',
  //   menu_type: 'tab',
  //   url: '',
  //   component: '/src/views/customer/index.vue',
  //   keepalive: 0,
  //   extend: 'none',
  //   children: [
  //     {
  //       id: 100031,
  //       pid: 10003,
  //       type: 'menu',
  //       title: '编辑客户',
  //       name: 'customerEdit',
  //       path: 'customer/edit/:customerId(\\S+)?',
  //       menu_type: 'tab',
  //       url: '',
  //       component: '/src/views/customer/edit.vue',
  //       keepalive: 0,
  //       extend: 'none',
  //       hidden: true
  //     },
  //     {
  //       id: 100032,
  //       pid: 10003,
  //       type: 'menu',
  //       title: '新增客户',
  //       name: 'customerAdd',
  //       path: 'customer/add',
  //       menu_type: 'tab',
  //       url: '',
  //       component: '/src/views/customer/edit.vue',
  //       keepalive: 0,
  //       extend: 'none',
  //       hidden: true
  //     }
  //   ]
  // },
  // {
  //   id: 10003,
  //   pid: 0,
  //   type: 'menu',
  //   title: '角色管理',
  //   name: 'role',
  //   path: 'role',
  //   menu_type: 'tab',
  //   url: '',
  //   component: '/src/views/role/index.vue',
  //   keepalive: 'role',
  //   extend: 'none',
  //   children: [
  //     {
  //       id: 100031,
  //       pid: 10003,
  //       type: 'menu',
  //       title: '编辑角色',
  //       name: 'roleEdit',
  //       path: 'role/edit/:rid(\\S+)?',
  //       menu_type: 'tab',
  //       url: '',
  //       component: '/src/views/role/roleEdit.vue',
  //       keepalive: 0,
  //       extend: 'none',
  //       hidden: false
  //     },
  //     {
  //       id: 100032,
  //       pid: 10003,
  //       type: 'menu',
  //       title: '新增角色',
  //       name: 'roleAdd',
  //       path: 'role/add',
  //       menu_type: 'tab',
  //       url: '',
  //       component: '/src/views/role/roleEdit.vue',
  //       keepalive: 0,
  //       extend: 'none',
  //       hidden: false
  //     }
  //   ]
  // },
  // {
  //   id: 10004,
  //   pid: 0,
  //   type: 'menu',
  //   title: '账号管理',
  //   name: 'account',
  //   path: 'account',
  //   menu_type: 'tab',
  //   url: '',
  //   component: '/src/views/account/index.vue',
  //   keepalive: 0,
  //   extend: 'none',
  //   children: [
  //     {
  //       id: 100041,
  //       pid: 10004,
  //       type: 'menu',
  //       title: '编辑账号',
  //       name: 'accountEdit',
  //       path: 'account/edit/:accountId(\\d+)?',
  //       menu_type: 'tab',
  //       url: '',
  //       component: '/src/views/account/edit.vue',
  //       keepalive: 0,
  //       extend: 'none',
  //       hidden: true
  //     },
  //     {
  //       id: 100042,
  //       pid: 10004,
  //       type: 'menu',
  //       title: '新增账号',
  //       name: 'accountAdd',
  //       path: 'account/add',
  //       menu_type: 'tab',
  //       url: '',
  //       component: '/src/views/account/edit.vue',
  //       keepalive: 0,
  //       extend: 'none',
  //       hidden: true
  //     }
  //   ]
  // }
]

export { staticRoutes, adminBaseRoute, mockApiStaticRoutes }
